import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api, type OrderView } from "../lib/api";

export function OrdersPage() {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState<OrderView[]>([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user) return;
    void api.orders().then((result) => setOrders(result.items)).catch((reason: Error) => setError(reason.message));
  }, [user]);

  if (loading) return <div className="page-loading">Loading purchase history…</div>;
  if (!user) return <section className="auth-gate"><h1>Sign in to view purchases</h1><Link className="button primary" to="/account">Sign in</Link></section>;

  return <section className="account-page orders-page">
    <p className="eyebrow">PURCHASE HISTORY</p>
    <h1>Your orders</h1>
    <p>PayPal purchases, refunds and disputes appear here.</p>
    {error && <p className="form-error">{error}</p>}
    {orders.length === 0 ? <div className="empty-state"><h2>No purchases yet</h2><Link className="button primary" to="/pricing">View plans</Link></div> :
      <div className="order-list">{orders.map((order) => <article key={order.id}>
        <div><strong>{order.planName}</strong><small>{new Date(order.createdAt).toLocaleString()}</small></div>
        <div><strong>${order.amountUsd.toFixed(2)}</strong><span className={`order-status status-${order.status}`}>{order.status}</span></div>
      </article>)}</div>}
  </section>;
}
